<form autocomplete="off" class="p-0 tbbb" novalidate [formGroup]="documentDetailsForm">
    <div class="col-lg-12 col-md-12">
        <div class="mt-3">
            <div>
                <h3 class="main-content-label mb-2"><b>
                        <img alt="Logo" width="20vh" src="../../assets/images/document.png"
                            class="mh-45px mrl mt-1 pb-2">
                        Document Details</b></h3>
            </div>
            <div class="row clearfix">
                <div class="table-responsive">
                    <table id="datatable" class="table tw table-bordered text-nowrap text-left">
                        <thead>
                            <tr class="text-left">

                                <th class="f600" style="width: 20%;">
                                    Document Name
                                </th>
                                <th class="f600 " style="width: 20%;" *ngIf="fileNameinput">
                                    Document Upload
                                </th>
                                <th class="f600" style="width: 20%;">
                                    Document No.
                                </th>
                                <th class="f600" style="width: 20%;">
                                    Issue Date
                                </th>
                                <th class="f600" style="width: 20%;">
                                    Expiry Date
                                </th>

                                <th style="width: 10%;" *ngIf="isDivShow==true">
                                    View
                                </th>
                            </tr>
                        </thead>
                        <tbody id="table_data" formArrayName="arrData">
                            <tr class="text-center" [formGroupName]="i"
                                *ngFor="let row of documentDetailsForm.get('arrData')['controls']; let i = index; let last = last"
                                [ngClass]="checkcolor(row)">

                                <td>
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-label class="lable_style2">Document Name :</mat-label>
                                        <input type="text" readonly formControlName="DocumentName" matInput
                                            placeholder="Document Name" [ngClass]="{'red-text': isRedText}">
                                        <mat-error class="margin_tp"
                                            *ngIf="row.controls.DocumentName.touched && row.controls.DocumentName.errors?.required">
                                            Mandatory
                                        </mat-error>
                                    </mat-form-field>
                                </td>
                                <td *ngIf="fileNameinput">
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <input type="text" readonly hidden matInput formControlName="DocumentFile" />
                                        <input type="file" id="i" placeholder="File" accept=".pdf" aria-label="FIle"
                                            formControlName="docFile" (change)="onChange($event,i)"
                                            onkeydown="return (event.keyCode!=13);" class="file-input" />

                                        <mat-error class="mt-1"
                                            *ngIf="row.controls.DocumentFile.touched && row.controls.DocumentFile.errors?.required">
                                            Mandatory
                                        </mat-error>
                                    </mat-form-field>
                                </td>
                                <td>
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-label class="lable_style2">Document No</mat-label>
                                        <input type="text" formControlName="StuSrNo" matInput
                                            placeholder="Document Details" (change)="onInputChange($event,i)">
                                        <mat-error class="mt-1"
                                            *ngIf="row.controls.StuSrNo.touched && row.controls.StuSrNo.errors?.required">
                                            Mandatory
                                        </mat-error>
                                        <mat-error class="mt-1"
                                            *ngIf="row.controls.StuSrNo.touched && row.controls.StuSrNo.errors?.Duplicate">
                                            Duplicate value entered.
                                        </mat-error>
                                    </mat-form-field>
                                </td>
                                <td *ngIf="row.controls.HasExpiryDate">
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-label class="lable_style2">Issue Date</mat-label>
                                        <input (dateChange)="issueDateValidation(row,i)" formControlName="StuDocIssue"
                                            matInput [matDatepicker]="issueDate" placeholder="Issue Date">
                                        <mat-datepicker-toggle matSuffix [for]="issueDate"></mat-datepicker-toggle>
                                        <mat-datepicker #issueDate></mat-datepicker>
                                        <mat-error class="mt-1"
                                            *ngIf="row.controls.StuDocIssue.touched && row.controls.StuDocIssue.errors?.required">
                                            Mandatory.
                                        </mat-error>
                                    </mat-form-field>
                                </td>
                                <td *ngIf="row.controls.HasExpiryDate">
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-label class="lable_style2">Expiry Date</mat-label>
                                        <input (dateChange)="toDateValidation(row,i)" formControlName="StuDocExpiry"
                                            matInput [matDatepicker]="expiryDate" placeholder="Expiry Date">
                                        <mat-datepicker-toggle matSuffix [for]="expiryDate"></mat-datepicker-toggle>
                                        <mat-datepicker #expiryDate></mat-datepicker>
                                        <mat-error class="mt-1"
                                            *ngIf="row.controls.StuDocExpiry.touched && row.controls.StuDocExpiry.errors?.required">
                                            Mandatory.
                                        </mat-error>
                                    </mat-form-field>
                                </td>
                                <td *ngIf="isDivShow==true" (click)="showbase64(row)">
                                    <a><label class="blue_col">View</label></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h6 class="mb-3 mt-3 redCol"><b>
                        * Note: Please upload only PDF file.</b></h6>
                <h3 class="main-content-label mb-1"><b>
                        Remark</b></h3>
                <div class="col-sm-12" [formGroup]="documentDetailsForm">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Remark</mat-label>
                        <textarea matInput class="color" maxlength="250" formControlName="StuRemarkConfirm"
                            cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"
                            cdkAutosizeMaxRows="5"></textarea>
                    </mat-form-field>
                </div>
                <div class="col-sm-12" [formGroup]="documentDetailsForm">
                    <div class="form-group">
                        <mat-checkbox required class="example-full-width " formControlName="StuRemarkCheck">
                            I hereby confirm that I have read all instructions carefully. (Please tick the checkbox if
                            you want to proceed)
                        </mat-checkbox>
                        <mat-error class="margin_tp"
                            *ngIf="documentDetailsForm.controls['StuRemarkCheck'].touched && documentDetailsForm.controls['StuRemarkCheck'].errors?.required">
                            Mandatory
                        </mat-error>
                    </div>
                </div>
                <div class="row mb-2 prpl">
                    <div class="col-sm-12">
                        <button type="button" *ngIf="submitButton" [disabled]="disabled"
                            class="btn btn-primary fr sz btn-icon-text floatright mt-1"
                            (click)="submitStudentDetails()">
                            <span style="display: contents;">
                                <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button type="button" *ngIf="updateButton" [disabled]="disabled" (click)="update()"
                            class="btn btn-primary fr sz btn-icon-text floatright mt-1">
                            <span style="display: contents;">
                                <img width="20vh" src="../../assets/images/edit.gif" style="margin-right: 5px;">
                                Update
                            </span>
                        </button>
                        <button type="button" [disabled]="printDisabled" (click)="Print()"
                            class="btn btn-primary fr sz btn-icon-text floatright mt-1">
                            <span style="display: contents;">
                                <img width="20vh" src="../../assets/images/printer.gif" style="margin-right: 5px;">
                                Print
                            </span>
                        </button>
                        <button type="button" (click)="back()" class="btn fr btn-primary btn-icon-text floatright mt-1">
                            <span style="display: contents;">
                                <img width="20vh" src="../../assets/images/turn-left.gif" style="margin-right: 5px;">
                                Back
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>